/**
 * Avatar: a foto da pessoa, ou as iniciais dela.
 *
 * ## Por que a imagem sai do nosso servidor
 *
 * A CSP é `img-src 'self' data:`. Apontar a `<img>` direto para o Graph seria
 * bloqueado pelo navegador — e, mesmo sem CSP, exigiria o token da Microsoft no
 * navegador, que é justamente o que o BFF existe para evitar.
 *
 * ## As iniciais não são plano B, são o caso comum
 *
 * A maioria das contas corporativas não tem foto no perfil. Quando não há, a
 * rota responde **204**, o navegador dispara `error` na `<img>` e caímos nas
 * iniciais. Por isso o `<span>` das iniciais é sempre renderizado e a imagem
 * fica por cima: não há salto de layout nem quadro vazio piscando enquanto a
 * foto carrega.
 */
import { useState } from 'react';

/**
 * Classes escritas por extenso, e nao montadas com `avatar-${size}`.
 *
 * O `css-contract.test.js` cruza a classe usada no JSX com a definida na
 * folha, e template literal esconde o nome final dele — a guarda deixaria de
 * valer justamente para as classes novas. Um mapa explicito custa tres linhas
 * e mantem a verificacao de pe.
 */
const SIZES = { sm: 'avatar-sm', md: 'avatar-md' };

export function Avatar({ src, initials, name, size = 'md' }) {
  // Uma vez que falhou, não tenta de novo: sem isto, cada nova renderização
  // refaz a requisição que já se sabe que responde 204.
  const [failed, setFailed] = useState(false);

  const showPhoto = Boolean(src) && !failed;

  return (
    <span className={`avatar ${SIZES[size] ?? SIZES.md}`} data-photo={showPhoto ? 'yes' : 'no'}>
      {/* aria-hidden: quem lê com leitor de tela já recebe o nome da pessoa
          pelo texto ao lado. Anunciar "AS" antes dele só atrapalha. */}
      <span className="avatar-initials" aria-hidden="true">
        {initials ?? '?'}
      </span>

      {showPhoto && (
        <img
          className="avatar-photo"
          src={src}
          alt={name ? `Foto de ${name}` : ''}
          loading="lazy"
          decoding="async"
          onError={() => setFailed(true)}
        />
      )}
    </span>
  );
}

export default Avatar;
